import { render, staticRenderFns } from "./CustomRatingEditModal.vue?vue&type=template&id=2a89e196&"
import script from "./CustomRatingEditModal.vue?vue&type=script&lang=js&"
export * from "./CustomRatingEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports